import React from 'react';
import BusinessInsights from './BussinessInsights/BussinessInsights';
import KnowledgeBase from './KnowledgeBase/KnowledgeBase';
import IntegrationTool from '../CompanyManagement/Integration';
import CompanyOnboarding from '../CompanyManagement/CompanyOnboarding';
import CustomerBase from '../CompanyManagement/CustomerBase';
import OffersBenefits from '../CompanyManagement/OffersBenefits';
import Competitors from '../CompanyManagement/Competitors';

const StepContent = ({ step, companyId, onCompanyCreated }) => {
  const renderContent = () => {
    switch (step) {
      case 1:
        return (
          <div className="container-fluid py-4">
            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-6">
                <CompanyOnboarding onCompanyCreated={onCompanyCreated} />
              </div>
            </div>
          </div>
        );
      case 2:
        return <CustomerBase companyId={companyId} />
      case 3:
        return <OffersBenefits companyId={companyId} />
      case 4:
        return <Competitors companyId={companyId} />
      case 5:
        return <BusinessInsights companyId={companyId} />
      case 6:
        return <KnowledgeBase />
      case 7:
        return <IntegrationTool />        

      default:
        return (
          <div className="container-fluid py-4 text-center">
            <h2 className="fw-semibold">Step {step}</h2>
            <p className="text-secondary">Content for step {step} goes here</p>
          </div>
        );
    }
  };

  return renderContent();
};

export default StepContent;